import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { IconCircleFilled, IconX } from "@tabler/icons-react";
import { Input } from "./Input";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Loading from "./Loading";
import { useState } from "react";
import { fightCreateGraduation, graduationColors } from "../services/store";

const GraduationRegister = ({
  open,
  fightsId,
  onClose,
  refetch,
}: {
  open: boolean;
  fightsId: string;
  onClose: () => void;
  refetch: () => void;
}) => {
  const [color, setColor] = useState("");

  const {
    data: colors,
    isLoading: isLoadingColors,
    isFetching: isFetchingColors,
  }: {
    data: Array<{
      id: number;
      name: string;
      hex: string;
    }>;
    isLoading: boolean;
    isFetching: boolean;
  } = useQuery({
    queryFn: graduationColors,
    queryKey: ["graduationColors"],
    initialData: [],
  });

  const { mutate, isPending } = useMutation({
    mutationFn: fightCreateGraduation,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Modalidade atualizada");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { values, handleSubmit, handleChange } = useFormik({
    initialValues: {
      color: "",
      belt: "",
      minClass: "",
      minMonthTime: "",
    },
    onSubmit: (values) => {
      mutate({ ...values, fightsId, color });
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending || isLoadingColors || isFetchingColors} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Graduação
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="belt"
              name="belt"
              label="Graduação"
              placeholder="Graduação"
              type="text"
              fullWidth
              size="small"
              value={values.belt}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Typography sx={{ fontWeight: 700, fontSize: 12 }}>Cor</Typography>
            <Select
              sx={{ marginTop: 1 }}
              id="fightId"
              value={color}
              fullWidth
              // onChange={handleChange}
            >
              {colors?.map((item) => (
                <MenuItem
                  key={item?.id}
                  value={item?.hex}
                  onClick={() => setColor(item?.hex)}
                >
                  <Stack
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <IconCircleFilled color={item.hex} />
                    <Typography>{item?.name}</Typography>
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="minClass"
              name="minClass"
              label="Aulas minimas"
              placeholder="Aulas minimas"
              type="text"
              fullWidth
              size="small"
              value={values.minClass}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="minMonthTime"
              name="minMonthTime"
              label="Tempo mínimo (mês)"
              placeholder="Tempo mínimo"
              type="text"
              fullWidth
              size="small"
              value={values.minMonthTime}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={() => handleSubmit()}
            >
              Criar graduação
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default GraduationRegister;
